import { CONNECTOR_CHANNEL_PREFIX, CONNECTOR_HYDRO_KEYS, INDICATOR_CHART_TYPES, type DeviceDto, type IndicatorDto } from '@atnt/shared';

/** "O'LCHOV BIRLIGINI TANLANG" presets (03-modules §4.6); free text is allowed too. */
export const UNIT_PRESETS = ['mm', 'm', 'sm', '°C', 'bar', 'kPa', 'MPa', 'mA', 'V', '%', 'l/s', 'm³/s', 'mm/m', '°'] as const;

export const CHART_TYPES = INDICATOR_CHART_TYPES;

/** "RANGI" swatches: the accent palette of 556:16647 (Qizil as the solid danger red — a chart colour must be opaque). */
export const COLOR_PRESETS = [
  { value: '#0275FF', key: 'blue' },
  { value: '#1ECD15', key: 'green' },
  { value: '#509F67', key: 'darkGreen' },
  { value: '#F4B400', key: 'yellow' },
  { value: '#F48200', key: 'orange' },
  { value: '#E10202', key: 'red' },
  { value: '#DF0259', key: 'pink' },
  { value: '#7059FF', key: 'purple' },
] as const;

/** Unified-server channels of the connector (`hydro:LEVEL` …). */
export const CHANNEL_PRESETS = CONNECTOR_HYDRO_KEYS.map((k) => `${CONNECTOR_CHANNEL_PREFIX}${k}`);

export const PRECISIONS = [0, 1, 2, 3, 4, 5, 6] as const;

export interface IndicatorRef {
  indicator: IndicatorDto;
  device: DeviceDto;
}

/** Every indicator of the tenant with its device, in device order. */
export function indicatorRefs(devices: readonly DeviceDto[] | undefined, kind?: IndicatorDto['kind']): IndicatorRef[] {
  return (devices ?? []).flatMap((device) =>
    device.indicators.filter((i) => !kind || i.kind === kind).map((indicator) => ({ indicator, device })),
  );
}

/** "Bosimli pezometr PZ01 · Sath" */
export const indicatorLabel = (r: IndicatorRef) => `${r.device.name} · ${r.indicator.name}`;

/** A free code for a new device / indicator: slug, then "-2", "-3"… when taken. */
export function uniqueCode(base: string, taken: Iterable<string>) {
  const used = new Set([...taken].map((c) => c.toLowerCase()));
  if (!used.has(base.toLowerCase())) return base;
  for (let n = 2; n < 1000; n++) {
    const candidate = `${base.slice(0, 60)}-${n}`;
    if (!used.has(candidate.toLowerCase())) return candidate;
  }
  return `${base.slice(0, 50)}-${Date.now().toString(36)}`;
}
